import { queryOptions, useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { getSymbols, GetSymbolsParams } from './getSymbols';

/** @deprecated Avoid directly use, Use unified price hook instead for single entry point */
export const useBenchmarkSymbols = (params: GetSymbolsParams) => {
  const reactQueryOptions = useMemo(() => {
    return queryOptions({
      queryKey: getKey(params),
      queryFn: getFn(params),
    });
  }, [params]);

  return useQuery(reactQueryOptions);
};

const getKey = (params: GetSymbolsParams) => {
  return ['pyth-benchmark/symbols', params];
};

const getFn = (params: GetSymbolsParams) => () => getSymbols(params);

useBenchmarkSymbols.getQueryKey = getKey;
useBenchmarkSymbols.getQueryFn = getFn;
